/** @jsx jsx */

import { Spacing } from '@zapier/theme';
import { jsx, css } from '@emotion/core';

import AutoCompleteTextInput from 'app/common/components/AutoCompleteTextInput';
import RequestMethodPicker from 'app/developer-v3/components/RequestMethodPicker';
import { ErrorList } from 'app/developer-v3/types/validator';
import { FieldErrorMessage } from 'app/developer-v3/components/FieldMessage';
import { RequestMethodTypes } from 'app/developer-v3/types/request';

const gutter = '15px';
const widthPicker = '130px';

const Styles = {
  root: css`
    padding: ${Spacing.medium}px;
  `,
  editor: css`
    align-items: center;
    display: grid;
    grid-template-columns: ${widthPicker} auto;
    grid-gap: ${gutter};
    height: 50px;
  `,
  input: css`
    display: flex;
    height: 100%;
  `,
  error: css`
    margin-left: calc(${widthPicker} + ${gutter});
  `,
};

type Props = {
  error: ErrorList | string;
  labelText: string;
  method: RequestMethodTypes;
  onBlurUrl: () => void;
  onChangeMethod: (method: RequestMethodTypes) => void;
  onChangeUrl: (value: string) => void;
  placeholder: string;
  url: string;
};

const BasicUrl = (props: Props) => (
  <section aria-label={`Configure ${props.labelText} URL`} css={Styles.root}>
    <div css={Styles.editor}>
      <RequestMethodPicker
        defaultValue={props.method}
        onChange={props.onChangeMethod}
      />
      <div css={Styles.input}>
        <AutoCompleteTextInput
          ariaLabel={`${props.labelText} URL`}
          error={props.error}
          onBlur={props.onBlurUrl}
          onChangeValue={props.onChangeUrl}
          placeholder={props.placeholder}
          value={props.url}
        />
      </div>
    </div>
    {props.error && (
      <aside css={Styles.error}>
        <FieldErrorMessage message={props.error} />
      </aside>
    )}
  </section>
);

BasicUrl.defaultProps = {
  placeholder: 'ex: https://www.example.com',
  url: '',
};

export default BasicUrl;
